import { useCallback, useState } from 'react';
import { useEffect } from 'react';
import { usePersistentStorage } from '../usePersistentStorage';
import { decryptPlanType, encryptPlanType } from './utils';
import type { PlanType } from '@simplywallst/services/types/endpoints/getUacCheck';
import { useUserAccess } from '../useUserAccess';

const ENCRYPTED_USER_ACCESS_PLAN_TYPE_KEY = '_sws_uwe74hff83fu';

export const useSetPlanTypeToStorage = () => {
  const { set } = usePersistentStorage();
  const { data: userAccess, status: userAccessStatus } = useUserAccess();
  useEffect(() => {
    if (userAccessStatus === 'success' && userAccess.planType !== null) {
      const value = encryptPlanType(userAccess.planType);
      set(ENCRYPTED_USER_ACCESS_PLAN_TYPE_KEY, value);
    }
  }, [set, userAccess, userAccessStatus]);
};

export const useGetPlanTypeFromStorage = () => {
  const { get } = usePersistentStorage();

  const [guestPlanType, setGuestPlanType] = useState<PlanType>('');
  useEffect(() => {
    const handlePlanTypeFromLocalStorage = async () => {
      try {
        const encryptedPlanType = await get(
          ENCRYPTED_USER_ACCESS_PLAN_TYPE_KEY
        );
        if (encryptedPlanType) {
          const planType = decryptPlanType(encryptedPlanType);
          setGuestPlanType(planType);
        }
      } catch (error) {
        console.error(error);
      }
    };

    handlePlanTypeFromLocalStorage();
  }, [get]);

  return { guestPlanType };
};

export const useFlushPlanType = () => {
  const { flush } = usePersistentStorage();

  const flushPlanType = useCallback(async () => {
    await flush(ENCRYPTED_USER_ACCESS_PLAN_TYPE_KEY);
  }, [flush]);

  return { flushPlanType };
};
